import { Injectable } from '@angular/core';

const GLOBAL_STUDIO_ID_KEY = 'selected_studio_id';
const LEGACY_SELECT_STUDIO_KEY = 'select.studio';
const LEGACY_NGSTORAGE_STUDIO_KEY = 'ngStorage-studio';

@Injectable({ providedIn: 'root' })
export class StudioSelectionService {
  restore(studios: any[], pageKey?: string, fallbackToSingleStudio = true): any | null {
    const savedId = this.getSavedStudioId(pageKey);
    if (savedId) {
      const found = studios.find((s: any) => String(s.id) === savedId);
      if (found) {
        this.save(found, pageKey);
        return found;
      }
    }

    if (fallbackToSingleStudio && studios.length === 1) {
      this.save(studios[0], pageKey);
      return studios[0];
    }

    return null;
  }

  save(studio: any, pageKey?: string): void {
    if (!studio?.id) return;
    const id = String(studio.id);
    sessionStorage.setItem(GLOBAL_STUDIO_ID_KEY, id);
    if (pageKey) {
      sessionStorage.setItem(pageKey, id);
    }
    sessionStorage.setItem(LEGACY_SELECT_STUDIO_KEY, JSON.stringify(studio));
  }

  clear(pageKey?: string): void {
    sessionStorage.removeItem(GLOBAL_STUDIO_ID_KEY);
    sessionStorage.removeItem(LEGACY_SELECT_STUDIO_KEY);
    sessionStorage.removeItem(LEGACY_NGSTORAGE_STUDIO_KEY);
    if (pageKey) {
      sessionStorage.removeItem(pageKey);
    }
  }

  private getSavedStudioId(pageKey?: string): string | null {
    const candidates = [
      sessionStorage.getItem(GLOBAL_STUDIO_ID_KEY),
      pageKey ? sessionStorage.getItem(pageKey) : null,
      this.readStudioObjectId(sessionStorage.getItem(LEGACY_SELECT_STUDIO_KEY)),
      this.readStudioObjectId(sessionStorage.getItem(LEGACY_NGSTORAGE_STUDIO_KEY)),
    ];
    return candidates.find((v): v is string => !!v) ?? null;
  }

  private readStudioObjectId(raw: string | null): string | null {
    if (!raw) return null;
    try {
      const parsed = JSON.parse(raw);
      return parsed?.id ? String(parsed.id) : null;
    } catch {
      return null;
    }
  }
}
